<script lang="ts">
	import type { ComponentProps } from 'svelte'
	import PartEditor from './PartEditor.svelte'

	type Props = Omit<
		ComponentProps<typeof PartEditor>,
		'embedded' | 'visibleTabs' | 'onSaved' | 'onReload' | 'onTabChange'
	>

	let {
		asr,
		clearScreenOnSave,
		part = $bindable(),
		attachments = $bindable(),
		typeFields = $bindable(),
		origPart = $bindable(),
		optionValueMap = $bindable(),
		tab = $bindable('basic'),
		...rest
	}: Props = $props()

	let partEditor: PartEditor | undefined = $state()

	export function canLeaveState() {
		return partEditor?.canLeaveState() ?? true
	}
</script>

<PartEditor
	{...rest}
	{asr}
	{clearScreenOnSave}
	bind:part
	bind:attachments
	bind:typeFields
	bind:origPart
	bind:optionValueMap
	bind:tab
	bind:this={partEditor}
	onSaved={savedPart => {
		// Reload the state so everything gets refreshed from the server
		asr.go(
			null,
			{
				loadCachedPart: false,
				sku: $clearScreenOnSave ? null : savedPart.sku,
				lastSavedTime: Date.now(),
				tab,
			},
			{ replace: true },
		)
	}}
	onReload={() => asr.go(null, { lastResetTime: Date.now() }, { replace: true, inherit: true })}
	onTabChange={tab => asr.go(null, { tab }, { inherit: true })}
></PartEditor>
